"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _useCurrentHeight = require("./useCurrentHeight");
Object.keys(_useCurrentHeight).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _useCurrentHeight[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _useCurrentHeight[key];
    }
  });
});